import { Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { useCallback, memo } from 'react';
import { validationSchema } from './constants';
import { PmiButton } from 'shell/components/shared/button';
import { PmiTextField } from 'shell/components/shared/text-field';

export interface FunctionForm {
  id: string;
  name: string;
  entity: string;
  event: string;
  contextLastUpdate: string;
}

interface FormFunctionProps {
  onOk: (form?: FunctionForm) => void;
  onCancel: (form?: FunctionForm) => void;
  title: string;
  disabled?: boolean;
  initialValues?: FunctionForm;
}

const FormFunctionComponent = ({
  onOk,
  onCancel,
  title,
  disabled = false,
  initialValues,
}: FormFunctionProps): React.ReactElement => {
  const onSubmit = useCallback(
    (formValues) => {
      onOk(formValues);
    },
    [onOk]
  );

  const filtersFunctionsForm = useFormik({
    initialValues: initialValues || {
      id: '',
      name: '',
      entity: '',
      event: '',
      contextLastUpdate: '',
    },
    validationSchema: validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={filtersFunctionsForm.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2" color="secondary">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="ID Funzione"
                  label="ID Funzione"
                  id="id"
                  name="id"
                  fullWidth
                  type="text"
                  variant="outlined"
                  value={filtersFunctionsForm.values.id}
                  disabled
                  onChange={filtersFunctionsForm.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <PmiTextField
                  aria-label="Nome funzione"
                  label="Nome funzione"
                  id="name"
                  name="name"
                  fullWidth
                  inputProps={{ maxLength: '50' }}
                  type="text"
                  variant="outlined"
                  value={filtersFunctionsForm.values.name}
                  disabled={disabled}
                  onChange={filtersFunctionsForm.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <PmiTextField
                  aria-label="Entità"
                  label="Entità"
                  id="entity"
                  name="entity"
                  fullWidth
                  inputProps={{ maxLength: '50' }}
                  type="text"
                  variant="outlined"
                  value={filtersFunctionsForm.values.entity}
                  disabled={disabled}
                  onChange={filtersFunctionsForm.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <PmiTextField
                  aria-label="Evento"
                  label="Evento"
                  id="event"
                  name="event"
                  fullWidth
                  inputProps={{ maxLength: '50' }}
                  type="text"
                  variant="outlined"
                  value={filtersFunctionsForm.values.event}
                  disabled={disabled}
                  onChange={filtersFunctionsForm.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <PmiTextField
                  aria-label="Contesto ultimo aggiornamento"
                  label="Contesto ultimo aggiornamento"
                  id="contextLastUpdate"
                  name="contextLastUpdate"
                  fullWidth
                  inputProps={{ maxLength: '50' }}
                  type="text"
                  variant="outlined"
                  value={filtersFunctionsForm.values.contextLastUpdate}
                  disabled={disabled}
                  onChange={filtersFunctionsForm.handleChange}
                />
              </Grid>
            </Grid>
          </div>
        </CardContent>
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel(filtersFunctionsForm.values);
            }}
          >
            Indietro
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

FormFunctionComponent.displayName = 'Form Institution component';

const FormFunction = memo(FormFunctionComponent);

export default FormFunction;
